import type { ModelDealViewRow } from '@/services/underwritingWorkbooks'
import { formatFieldValue } from './format'

const DASH = '—'

/**
 * A gap between two rates, in percentage points.
 *
 * The percent formatter reads any magnitude under 1.5 as a fraction and
 * multiplies it by a hundred — right for a stored 0.65 LTV, wrong for a 0.23
 * difference between a 5.02% and a 4.79% cap rate, which printed "+23%". The
 * scale comes from the two values being compared, never from the gap itself.
 */
function percentPointGap(row: ModelDealViewRow, absolute: number): string {
  const dealNumber = typeof row.dealValue === 'number' ? row.dealValue : Number(row.dealValue)
  const largest = Math.max(Math.abs(row.modelValue), Number.isFinite(dealNumber) ? Math.abs(dealNumber) : 0)
  const points = largest <= 1.5 ? absolute * 100 : absolute
  return `${Number(points.toFixed(2))} pts`
}

export function formatDelta(row: ModelDealViewRow): string {
  if (!row.delta) return DASH
  if (row.delta.agrees) return 'agrees'
  const sign = row.delta.absolute > 0 ? '+' : ''
  const abs = row.kind === 'percent'
    ? percentPointGap(row, row.delta.absolute)
    : formatFieldValue(Math.abs(row.delta.absolute) * (row.delta.absolute < 0 ? -1 : 1), row.kind)
  if (row.delta.relative === null || !Number.isFinite(row.delta.relative)) return `${sign}${abs}`
  const pct = Math.round(row.delta.relative * 1000) / 10
  return `${sign}${abs} (${pct > 0 ? '+' : ''}${pct}%)`
}
